export const blockIconsTravelFestivalNew = (
	<span className='material-symbols-outlined'>festival</span>
);
